<template>
  <div>
    <h3 class="ts-text-xs ts-uppercase ts-text-blue-700">
      {{ $t('productProfile.productSaleCode') }}
    </h3>
    <table class="ts-w-full">
      <thead>
        <tr class="ts-bg-gray-100 ts-border-b">
          <th class="ts-uppercase ts-px-2 ts-py-1">
            {{ $t('productProfile.uom') }}
          </th>
          <th class="ts-uppercase ts-px-2 ts-py-1">
            {{ $t('productProfile.saleCode') }}
          </th>
          <th class="ts-uppercase ts-px-2 ts-py-1">
            {{ $t('productProfile.cost') }}
          </th>
          <th class="ts-uppercase ts-px-2 ts-py-1">
            {{ $t('productProfile.quantityInHand') }}
          </th>
          <th class="ts-uppercase ts-px-2 ts-py-1 ts-w-4">
            {{ $t('productProfile.grade') }}
          </th>
          <th class="ts-uppercase ts-px-2 ts-py-1 ts-text-right">
            {{ $t('productProfile.dealerPrice') }}
          </th>
          <th class="ts-uppercase ts-px-2 ts-py-1 ts-text-right">
            {{ $t('productProfile.salePrice') }}
          </th>
          <th class="ts-uppercase ts-px-2 ts-py-1 ts-text-right">
            {{ $t('productProfile.standardPrice') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(code, index) in model.product_sale_code" :key="index">
          <td class="ts-px-2 ts-py-1">
            {{ code.uom_name }}
          </td>
          <td class="ts-px-2 ts-py-1">
            <input
              type="text"
              v-model="code.sale_code"
              class="ts-border ts-px-2 ts-py-1 ts-rounded-md ts-outline-none"
              style="width: 120px;"
              :class="{
                'ts-border-red-600': errors.has(
                  'product_sale_code.' + index + '.sale_code'
                )
              }"
            />
          </td>
          <td class="ts-px-2 ts-py-1">
            <input
              type="text"
              v-model="code.cost"
              class="ts-border ts-px-2 ts-py-1 ts-rounded-md ts-outline-none"
              style="width: 120px;"
              :class="{
                'ts-border-red-600': errors.has(
                  'product_sale_code.' + index + '.cost'
                )
              }"
            />
          </td>
          <td class="ts-px-2 ts-py-1">
            <input
              type="number"
              v-model="code.quantity_in_hand"
              class="ts-border ts-px-2 ts-py-1 ts-rounded-md ts-outline-none"
              style="width: 80px;"
              :class="{
                'ts-border-red-600': errors.has(
                  'product_sale_code.' + index + '.quantity_in_hand'
                )
              }"
            />
          </td>
          <td class="ts-px-2 ts-py-1">
            <input
              type="text"
              v-model="code.grade"
              class="ts-border ts-px-2 ts-py-1 ts-rounded-md ts-outline-none ts-w-16"
              :class="{
                'ts-border-red-600': errors.has(
                  'product_sale_code.' + index + '.grade'
                )
              }"
            />
          </td>
          <td class="ts-text-right">
            <input
              type="number"
              v-model="code.dealer_price"
              class="
                ts-border
                ts-px-2
                ts-py-1
                ts-rounded-md
                ts-outline-none
                ts-text-right
								ts-w-32
              "
              :class="{
                'ts-border-red-600': errors.has(
                  'product_sale_code.' + index + '.dealer_price'
                )
              }"
            />
          </td>
          <td class="ts-text-right">
            <input
              type="number"
              v-model="code.sale_price"
              class="
                ts-border
                ts-px-2
                ts-py-1
                ts-rounded-md
                ts-outline-none
                ts-text-right
								ts-w-32
              "
              :class="{
                'ts-border-red-600': errors.has(
                  'product_sale_code.' + index + '.sale_price'
                )
              }"
            />
          </td>
          <td class="ts-text-right">
            <input
              type="number"
              v-model="code.vendor_standard_price"
              class="
                ts-border
                ts-px-2
                ts-py-1
                ts-rounded-md
                ts-outline-none
                ts-text-right
								ts-w-32
              "
              :class="{
                'ts-border-red-600': errors.has(
                  'product_sale_code.' + index + '.vendor_standard_price'
                )
              }"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'proSaleCode',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
